export { default as OptionContext } from './OptionContext';
export { default as Selector } from './Selector';

export interface Option {
  key:
    | 'topType'
    | 'accessoriesType'
    | 'hatColor'
    | 'hairColor'
    | 'facialHairType'
    | 'facialHairColor'
    | 'clotheType'
    | 'clotheColor'
    | 'graphicType'
    | 'eyeType'
    | 'eyebrowType'
    | 'mouthType'
    | 'skinColor';
  label: string;
}

export const TopOption: Option = {
  key: 'topType',
  label: 'Top',
};

export const AccessoriesOption: Option = {
  key: 'accessoriesType',
  label: '↳ 👓 Accessories',
};

export const HatColorOption: Option = {
  key: 'hatColor',
  label: '🎨 HatColor',
};

export const HairColorOption: Option = {
  key: 'hairColor',
  label: '↳ 💈 Hair Color',
};

export const FacialHairOption: Option = {
  key: 'facialHairType',
  label: 'Facial Hair',
};

export const FacialHairColor: Option = {
  key: 'facialHairColor',
  label: '↳ ✂️ Facial Hair Color',
};

export const ClotheOption: Option = {
  key: 'clotheType',
  label: '👔 Clothes',
};

export const ClotheColorOption: Option = {
  key: 'clotheColor',
  label: '↳ Color Fabric',
};

export const GraphicOption: Option = {
  key: 'graphicType',
  label: '↳ Graphic',
};

export const EyesOption: Option = {
  key: 'eyeType',
  label: '👁 Eyes',
};

export const EyebrowOption: Option = {
  key: 'eyebrowType',
  label: '✏️ Eyebrow',
};

export const MouthOption: Option = {
  key: 'mouthType',
  label: '👄 Mouth',
};

export const SkinOption: Option = {
  key: 'skinColor',
  label: '🎨 Skin',
};

export interface OptionList {
  topType?:
    | 'Eyepatch'
    | 'Hat'
    | 'Hijab'
    | 'LongHairBigHair'
    | 'LongHairBob'
    | 'LongHairBun'
    | 'LongHairCurly'
    | 'LongHairCurvy'
    | 'LongHairDreads'
    | 'LongHairFrida'
    | 'LongHairFro'
    | 'LongHairFroBand'
    | 'LongHairMiaWallace'
    | 'LongHairNotTooLong'
    | 'LongHairShavedSides'
    | 'LongHairStraight'
    | 'LongHairStraight2'
    | 'LongHairStraightStrand'
    | 'NoHair'
    | 'ShortHairDreads01'
    | 'ShortHairDreads02'
    | 'ShortHairFrizzle'
    | 'ShortHairShaggyMullet'
    | 'ShortHairShortCurly'
    | 'ShortHairShortFlat'
    | 'ShortHairShortRound'
    | 'ShortHairShortWaved'
    | 'ShortHairSides'
    | 'ShortHairTheCaesar'
    | 'ShortHairTheCaesarSidePart'
    | 'Turban'
    | 'WinterHat1'
    | 'WinterHat2'
    | 'WinterHat3'
    | 'WinterHat4';
  accessoriesType?:
    | 'Blank'
    | 'Kurt'
    | 'Prescription01'
    | 'Prescription02'
    | 'Round'
    | 'Sunglasses'
    | 'Wayfarers';
  hatColor?:
    | 'Black'
    | 'Blue01'
    | 'Blue02'
    | 'Blue03'
    | 'Gray01'
    | 'Gray02'
    | 'Heather'
    | 'PastelBlue'
    | 'PastelGreen'
    | 'PastelOrange'
    | 'PastelRed'
    | 'PastelYellow'
    | 'Pink'
    | 'Red'
    | 'White';
  hairColor?:
    | 'Auburn'
    | 'Black'
    | 'Blonde'
    | 'BlondeGolden'
    | 'Brown'
    | 'BrownDark'
    | 'PastelPink'
    | 'Blue'
    | 'Platinum'
    | 'Red'
    | 'SilverGray';
  facialHairType?:
    | 'BeardLight'
    | 'BeardMajestic'
    | 'BeardMedium'
    | 'Blank'
    | 'MoustacheFancy'
    | 'MoustacheMagnum';
  facialHairColor?:
    | 'Auburn'
    | 'Black'
    | 'Blonde'
    | 'BlondeGolden'
    | 'Brown'
    | 'BrownDark'
    | 'Platinum'
    | 'Red'
    | 'SilverGray';
  clotheType?:
    | 'BlazerShirt'
    | 'BlazerSweater'
    | 'CollarSweater'
    | 'GraphicShirt'
    | 'Hoodie'
    | 'Overall'
    | 'ShirtCrewNeck'
    | 'ShirtScoopNeck'
    | 'ShirtVNeck';
  clotheColor?:
    | 'Black'
    | 'Blue01'
    | 'Blue02'
    | 'Blue03'
    | 'Gray01'
    | 'Gray02'
    | 'Heather'
    | 'PastelBlue'
    | 'PastelGreen'
    | 'PastelOrange'
    | 'PastelRed'
    | 'PastelYellow'
    | 'Pink'
    | 'Red'
    | 'White';
  graphicType?:
    | 'Skull'
    | 'SkullOutline'
    | 'Bat'
    | 'Cumbia'
    | 'Deer'
    | 'Diamond'
    | 'Selena'
    | 'Pizza'
    | 'Resist'
    | 'Bear'
    | 'Hola';
  eyeType?:
    | 'Close'
    | 'Cry'
    | 'Default'
    | 'Dizzy'
    | 'EyeRoll'
    | 'Happy'
    | 'Hearts'
    | 'Side'
    | 'Squint'
    | 'Surprised'
    | 'Wink'
    | 'WinkWacky';
  eyebrowType?:
    | 'Angry'
    | 'AngryNatural'
    | 'Default'
    | 'DefaultNatural'
    | 'FlatNatural'
    | 'FrownNatural'
    | 'RaisedExcited'
    | 'RaisedExcitedNatural'
    | 'SadConcerned'
    | 'SadConcernedNatural'
    | 'UnibrowNatural'
    | 'UpDown'
    | 'UpDownNatural';
  mouthType?:
    | 'Concerned'
    | 'Default'
    | 'Disbelief'
    | 'Eating'
    | 'Grimace'
    | 'Sad'
    | 'ScreamOpen'
    | 'Serious'
    | 'Smile'
    | 'Tongue'
    | 'Twinkle'
    | 'Vomit';
  skinColor?:
    | 'Tanned'
    | 'Yellow'
    | 'Pale'
    | 'Light'
    | 'Brown'
    | 'DarkBrown'
    | 'Black';
}
